function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "6",
  height: "9",
  viewBox: "0 0 6 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.012 4.89l-3.7 2.96A.5.5 0 01.5 7.46V1.54a.5.5 0 01.812-.39l3.7 2.96a.5.5 0 010 .78z",
  fill: "#12002D",
  stroke: "#000",
  strokeLinecap: "round"
})));